function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { Trans } from "react-i18next";
import { Field } from "redux-form";
import { ButtonGroup } from "reactstrap";
import { FaRocket } from "react-icons/fa";
import NumericFormat from "../react-number-format/NumericFormat";
import Button from "../mui/material/Button";
var tKey = "components.redux-form.BoostField";
function BoostField(_ref) {
  var input = _ref.input,
    activateCallback = _ref.activateCallback,
    deactivateCallback = _ref.deactivateCallback,
    boosts = _ref.boosts;
  return /*#__PURE__*/React.createElement(ButtonGroup, null, boosts.map(function (boost) {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      key: boost.id,
      color: "light",
      className: "mt-2",
      onClick: function onClick() {
        if (input.value !== boost) {
          activateCallback(boost);
          input.onChange(boost);
        } else {
          deactivateCallback();
          input.onChange(null);
        }
      },
      active: input.value && input.value === boost,
      startIcon: /*#__PURE__*/React.createElement(FaRocket, null)
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "".concat(tKey, ".activate"),
      components: {
        amount: /*#__PURE__*/React.createElement(NumericFormat, {
          displayType: "text",
          value: boost.amount,
          style: {
            fontWeight: 600
          }
        }),
        small: /*#__PURE__*/React.createElement("small", null)
      },
      values: {
        unitAbbreviation: boost.currency.unitAbbreviation,
        durationInDays: boost.durationInDays
      }
    }));
  }));
}
export default (function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: BoostField
  }));
});